import { Component } from '@angular/core';

@Component({
    selector: 'app-hand-icon',
    standalone: true,
    imports: [],
    templateUrl: './hand-icon.component.html',
    styleUrl: './hand-icon.component.css'
})
export class HandIconComponent {

}
